import Event from 'mitt';

export default Event();